import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-images_style_1",
  "use": "icon-images_style_1-usage",
  "viewBox": "0 0 20 20.001",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20.001\" id=\"icon-images_style_1\">\r\n  <path id=\"icon-images_style_1_联合_70\" data-name=\"联合 70\" class=\"cls-1\" d=\"M20,20H0V0H20V20h0Zm-1.176-1.176V13.53H14.117v5.294Zm-5.882,0V13.53H7.647v5.294Zm-11.765,0H6.47V13.53H1.176Zm17.647-6.471V7.647H14.117v4.705Zm-5.882,0V7.647H7.647v4.705Zm-6.471,0V7.647H1.176v4.705ZM18.823,6.47V1.176H14.117V6.47Zm-5.882,0V1.176H7.647V6.47Zm-6.471,0V1.176H1.176V6.47Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol